import { combineReducers } from 'redux';
import chapters from 'memo/reducers/chapters';
import memo from 'memo/reducers/memo';
import history from 'memo/reducers/history';

export const memoReducer = combineReducers({
  memo,
  chapters,
  history,
});



// WEBPACK FOOTER //
// ./src/modules/memo/reducers/index.js